<template>
  <div class="comp-ly-skeleton">
    <div v-if="fromType === 'field'" class="field-skeleton">
      <jw-skeleton :animation="animation" class="field-skeleton-item">
        <jw-space direction="vertical" :style="{ width: '100%' }" size="large">
          <jw-skeleton-line :line-height="lineHeight" :rows="row" />
          <!-- <div class="field-skeleton-item-right">
            <jw-skeleton-shape size="large" />
            <jw-skeleton-shape class="field-skeleton-item-right-center" />
            <jw-skeleton-shape size="small" />
          </div> -->
        </jw-space>
      </jw-skeleton>
      <jw-skeleton :animation="animation" class="field-skeleton-item">
        <jw-skeleton-line :line-height="lineHeight" :rows="row" />
      </jw-skeleton>
    </div>
    <template v-else-if="fromType === 'cooperation'">
      <jw-skeleton :animation="animation" class="cooperation-skeleton">
        <jw-skeleton-shape shape="circle" size="small" />
        <jw-skeleton-shape shape="circle" size="small" class="cooperation-skeleton-item" />
        <!-- <jw-skeleton-shape shape="circle" size="small" /> -->
      </jw-skeleton>
    </template>
    <template v-else-if="fromType === 'mainTable'">
      <div class="main-table-skeleton" :style="{ height: listScroll + 'px' }">
        <div class="main-table-skeleton-title">
          <div class="main-table-skeleton-title-right">
            <template v-for="e in 4" :key="e">
              <jw-skeleton :animation="animation" class="main-table-skeleton-title-item">
                <jw-skeleton-line :line-height="24" :rows="1" />
              </jw-skeleton>
            </template>
          </div>
          <div class="main-table-skeleton-title-right">
            <jw-skeleton :animation="animation" class="main-table-skeleton-title-select">
              <jw-skeleton-line :line-height="24" :rows="1" />
            </jw-skeleton>
            <jw-skeleton :animation="animation" class="main-table-skeleton-title-select">
              <jw-skeleton-line :line-height="24" :rows="1" />
            </jw-skeleton>
            <template v-for="e in 4" :key="e">
              <jw-skeleton :animation="animation" class="main-table-skeleton-title-icon">
                <jw-skeleton-line :line-height="24" :rows="1" />
              </jw-skeleton>
            </template>
          </div>
        </div>
        <jw-row class="skeleton-grid" v-for="e in row" :key="e" :gutter="{ md: 8, lg: 24, xl: 32 }">
          <template v-for="(span, index) in colSpans" :key="index">
            <jw-col :span="span">
              <jw-skeleton :animation="animation" class="table-skeleton-item">
                <jw-skeleton-line :line-height="lineHeight" :rows="1" />
              </jw-skeleton>
            </jw-col>
          </template>
        </jw-row>
      </div>
    </template>
    <template v-else-if="fromType === 'table'">
      <div class="table-skeleton">
        <jw-space direction="vertical" fill>
          <template v-for="i in row" :key="i">
            <div class="table-skeleton-all" :style="{ height: lineHeight + 'px' }">
              <div class="table-skeleton-item" :style="{ width: item?.width ? item?.width + 'px' : getWidth(item?.fieldName) + 'px' }" v-for="item in tableColumns" :key="item"></div>
            </div>
          </template>
        </jw-space>
      </div>
    </template>
    <template v-else-if="fromType === 'filter'">
      <div class="filter-skeleton">
        <div class="filter-skeleton-header">
          <div class="filter-inner-title-wrapper">
            <jw-skeleton :animation="props.animation">
              <jw-skeleton-line :line-height="28" />
            </jw-skeleton>
          </div>
          <div class="filter-inner-title-wrapper">
            <jw-skeleton :animation="props.animation">
              <jw-skeleton-line :line-height="28" />
            </jw-skeleton>
          </div>
        </div>
        <div class="filter-skeleton-content">
          <jw-row align="start">
            <jw-col :span="2">
              <jw-skeleton :animation="props.animation">
                <jw-skeleton-shape />
              </jw-skeleton>
            </jw-col>
            <jw-col :span="22">
              <div class="filter-skeleton-inner">
                <jw-row :gutter="4" align="center">
                  <jw-col :span="1">
                    <jw-skeleton :animation="props.animation">
                      <jw-skeleton-line :line-height="32" :rows="1" />
                    </jw-skeleton>
                  </jw-col>
                  <jw-col :span="6">
                    <jw-skeleton :animation="props.animation">
                      <jw-skeleton-line :line-height="32" :rows="1" />
                    </jw-skeleton>
                  </jw-col>

                  <jw-col :span="4">
                    <jw-skeleton :animation="props.animation">
                      <jw-skeleton-line :line-height="32" :rows="1" />
                    </jw-skeleton>
                  </jw-col>

                  <jw-col :span="12">
                    <jw-skeleton :animation="props.animation">
                      <jw-skeleton-line :line-height="32" :rows="1" />
                    </jw-skeleton>
                  </jw-col>
                  <jw-col :span="1">
                    <jw-skeleton :animation="props.animation">
                      <jw-skeleton-line :line-height="32" :rows="1" />
                    </jw-skeleton>
                  </jw-col>
                </jw-row>
                <div class="filter-inner-btn">
                  <div class="filter-inner-btn-wrapper">
                    <jw-skeleton :animation="props.animation">
                      <jw-skeleton-line :line-height="28" />
                    </jw-skeleton>
                  </div>
                  <div class="filter-inner-btn-wrapper">
                    <jw-skeleton :animation="props.animation">
                      <jw-skeleton-line :line-height="28" />
                    </jw-skeleton>
                  </div>
                </div>
              </div>
              <!-- <jw-skeleton :animation="props.animation" class="filter-skeleton-shape">
                <jw-skeleton-shape shape="circle" size="small" />
              </jw-skeleton> -->
            </jw-col>
          </jw-row>
        </div>
        <div class="filter-skeleton-footer">
          <jw-skeleton :animation="animation" class="filter-footer-btn">
            <jw-skeleton-line :line-height="28" />
          </jw-skeleton>
          <div class="footer-btn-content" v-if="props.highFilter">
            <template v-for="e in 2" :key="e">
              <jw-skeleton :animation="animation" class="footer-btn">
                <jw-skeleton-line :line-height="28" />
              </jw-skeleton>
            </template>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="fromType === 'list-group'">
      <div class="list-group-skeleton">
        <div class="group-head">
          <template v-for="e in 2" :key="e">
            <jw-skeleton :animation="animation" class="group-head-wrapper">
              <jw-skeleton-line :line-height="28" />
            </jw-skeleton>
          </template>
        </div>
        <div class="group-content">
          <jw-skeleton :animation="animation" class="group-content-wrapper">
            <jw-skeleton-line :line-height="28" />
          </jw-skeleton>
        </div>
        <div class="group-footer">
          <template v-for="e in 2" :key="e">
            <jw-skeleton :animation="animation" class="group-footer-wrapper">
              <jw-skeleton-line :line-height="28" />
            </jw-skeleton>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <jw-skeleton :animation="animation" class="follow-skeleton-item">
        <jw-skeleton-line :line-height="lineHeight" :rows="props.row" />
      </jw-skeleton>
    </template>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { tools } from '@/utils/tools';
import useEventListener from '@/hooks/event-listener';

console.log('1-开始创建组件-setup');
const props = defineProps({
  fromType: {
    type: String,
    default: 'field'
  },
  animation: {
    type: Boolean,
    default: true
  },
  row: {
    type: Number,
    default: 1
  },
  colNum: {
    type: Number,
    default: 6
  },
  lineHeight: {
    type: Number,
    default: 26
  },
  tableColumns: {
    type: Array,
    default: () => []
  },
  highFilter: {
    type: Boolean,
    default: false
  }
});
const getWidth = (name) => {
  return tools.getStrLen(name) <= 6 ? 120 : tools.getStrLen(name) > 10 ? 220 : tools.getStrLen(name) * 20;
};
// 获取table-skeleton的实时宽度,根据字段宽度之和是否小于table-skeleton的宽度，如果小于则说明骨架屏占不满，此时需要使用他俩的差值来计算剩余宽度，并设置到table-skeleton-item的width上

// 获取随机数
// const generateArray = () => {
//   let result = [];
//   let sum = 0;
//   while (result.length < 8) {
//     let num = Math.floor(Math.random() * 5) + 2; // 生成2 - 6之间的随机数，包含2和6
//     sum += num;
//     result.push(num);
//   }
//   // 如果总和不等于24，进行调整
//   if (sum !== 24) {
//     let diff = sum - 24;
//     for (let i = 0; i < result.length; i++) {
//       if (result[i] - diff >= 2 && result[i] - diff <= 6) {
//         result[i] -= diff;
//         break;
//       }
//     }
//   }
//   return result;
// };
const colSpans = [5, 2, 3, 2, 3, 4, 3, 2]; // 根据实际的各列span值来配置
console.log(136, colSpans);
const { eventListener } = useEventListener();
onMounted(() => {
  windowHeight.value = window.innerHeight;
});
const windowHeight = ref(0);
const listScroll = ref(null);
// 列表高度监听
watch(
  () => windowHeight.value,
  (v) => {
    listScroll.value = v - 300 > 200 ? v - 125 : 300;
  },
  {
    deep: true,
    immediate: true
  }
);
const eventListen = () => {
  windowHeight.value = window.innerHeight;
};

eventListener('resize', eventListen);
</script>
<style scoped lang="less">
@import './ly-skeleton.less';
</style>
